import React, { useEffect, useState } from "react";
import {
  useCreateSupplierMutation,
  useDeleteSupplierMutation,
  useGetSuppliersQuery,
  useUpdateSupplierMutation,
} from "../../store/api/supplierApi";
import {
  useCreateProductMutation,
  useDeleteProductMutation,
  useGetProductsQuery,
  useUpdateProductMutation,
} from "../../store/api/productsApi";
import { FaRegEdit } from "react-icons/fa";
import { useGetNotificationsQuery } from "../../store/api/notificationApi";
import Swal from "sweetalert2";
import { BsFillCameraFill, BsTrashFill } from "react-icons/bs";
import DataTable from "react-data-table-component";
import { IoSearch } from "react-icons/io5";
import { useGetBusinessQuery } from "../../store/api/businessApi";
import { useGetCreditPurchaseQuery } from "../../store/api/creditPurchaseApi";

const initialSupplier = {
  Id: 0,
  name: "",
  phone: "",
  email: "",
};

export default function Suppliers() {
  const [isUpdate, setIsUpdate] = useState(false);
  const [supplier, setSupplier] = useState(initialSupplier);

  const [CreateSupplier] = useCreateSupplierMutation();
  const [updateSupplier] = useUpdateSupplierMutation();
  const [deleteSupplier] = useDeleteSupplierMutation();

  const [suppliersList, setSuppliersList] = useState([]);
  const { data } = useGetSuppliersQuery();

  const [dataBusiness, setBusinessData] = useState([]);
  const [dataCreditPurchase, setCreditPurchaseData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(18);
  const [formVendorData, setFormVendorData] = useState([]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentVendors = formVendorData.length
    ? formVendorData.slice(indexOfFirstItem, indexOfLastItem)
    : dataCreditPurchase.slice(indexOfFirstItem, indexOfLastItem);

  const handleVendorPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(dataCreditPurchase.length / itemsPerPage);
  const showPrevious = currentPage > 1;
  const showNext = currentPage < totalPages;

  const handleVendorPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    setItemsPerPage(newItemsPerPage);

    setCurrentPage(1);

    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  };

  // Fetch Business
  const { data: businnes } = useGetBusinessQuery();
  const { data: creditPurchase } = useGetCreditPurchaseQuery();

  useEffect(() => {
    if (creditPurchase && Array.isArray(creditPurchase)) {
      setCreditPurchaseData(creditPurchase);
    }
  }, [creditPurchase]);

  useEffect(() => {
    if (businnes && Array.isArray(businnes)) {
      setBusinessData(businnes);
    }
  }, [businnes]);

  // Update suppliers state when data changes

  useEffect(() => {
    if (data) {
      setSuppliersList(data);
    }
  }, [data]);

  // products  . . .

  const [file, setFile] = useState(null);
  // select file for the new product
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };

  // create new supplier method
  const handlecreateSupplier = async (event) => {
    event.preventDefault();

    const Data = {
      name: supplier.name,
      phone: supplier.phone,
      email: supplier.email === "" ? "example@gmail.com" : supplier.email,
      Logo: file,
    };

    await CreateSupplier(Data).then((done) => {
      console.log("done", done);
      if (done.data.status === 200) {
        Swal.fire({
          title: "Success!",
          text: done.data.message,
          icon: "success",
          confirmButtonText: "Done",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: done.data.message,
          icon: "error",
          confirmButtonText: "close",
        });
      }
    });

    // if (data && data.CreateSupplier) {
    //     Swal.fire({
    //         title: 'Success!',
    //         text: data.message,
    //         icon: 'success',
    //         confirmButtonText: 'Done'
    //       })
    // }
  };

  // update exist supplier
  const handleUpdateSupplier = async (e) => {
    e.preventDefault();

    const supplierData = {
      Id: supplier.Id,
      name: supplier.name,
      phone: supplier.phone,
      email: supplier.email,
      Logo: file,
    };

    await updateSupplier(supplierData).then((done) => {
      if (done?.data.status === 200) {
        Swal.fire({
          title: "Success!",
          text: done.data.message,
          icon: "success",
          confirmButtonText: "Done",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: done.data.message,
          icon: "error",
          confirmButtonText: "Close",
        });
      }
    });
    setIsUpdate(!isUpdate);
    resetFormData();
  };

  // Delete supplier

  const handleDelete = async (value) => {
    const { id } = value;
    Swal.fire({
      title: "Are you sure?",
      text: "you want to delete this supplier !!!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#022B3A",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteSupplier(id).then((done) => {
          if (done?.data.status === 200) {
            Swal.fire({
              title: "Success!",
              text: done.data.message,
              icon: "success",
              confirmButtonText: "Done",
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: done.data.message,
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      }
    });
  };

  const resetFormData = () => {
    setSupplier({
      ...initialSupplier,
    });
    setFile(null);
  };

  // reading suppliers list

  // prepare data supplier to be updated
  const handleUpdate = (updateData) => {
    if (!isUpdate) {
      setIsUpdate(!isUpdate);
    }

    setSupplier({
      Id: updateData.id,
      name: updateData.name,
      email: updateData.email,
      phone: updateData.phone,
    });
  };

  // search products
  const searchSuppliers = (searchText) => {
    if (!searchText) {
      return suppliersList;
    }

    const filteredSuppliersList = suppliersList.filter((supplier) => {
      const nameMatch = supplier.name
        .toLowerCase()
        .includes(searchText.toLowerCase());
      const phoneMatch = supplier.phone.toString() === searchText;
      return nameMatch || phoneMatch;
    });

    return filteredSuppliersList;
  };

  const searchVendorSuppliers = (searchText) => {
    if (!searchText) {
      return dataCreditPurchase;
    }

    const filteredSuppliersList = dataCreditPurchase.filter((supplier) => {
      const nameMatch = supplier.text
        .toLowerCase()
        .includes(searchText.toLowerCase());
      return nameMatch;
    });

    return filteredSuppliersList;
  };

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(3);
  const [formData, setFormData] = useState([]);

  // changes pages
  const handlePageChange = (page) => {
    setPage(page);
  };

  // change perpage
  const handlePerPageChange = (perPage) => {
    setPerPage(perPage);
  };

  const ResetFormChanges = () => {
    setIsUpdate(!isUpdate);
    setSupplier(initialSupplier);
    setFile(null);
  };

  // search hanlder

  const handleSearch = (e) => {
    setFormData(searchSuppliers(e.target.value));
  };

  const handleVendorSearch = (e) => {
    setFormVendorData(searchVendorSuppliers(e.target.value));
  };

  // Supplier Table columns
  const _columns = [
    { name: "Id", selector: (row) => row.id, sortable: true, center: true },
    {
      name: "Logo",
      selector: (row) => row.logo,
      cell: (row) => (
        <img
          src={`${row.logo}?timestamp=123456789`}
          alt="Logo"
          width="50"
          className="zoom-on-hover border border-2 rounded-1 m-1"
        />
      ),
      sortable: true,
      center: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
      center: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      center: true,
    },
    {
      name: "Create At",
      selector: (row) => row.created,
      sortable: true,
      center: true,
    },
    {
      name: "Updated At",
      selector: (row) => row.updated,
      sortable: true,
      center: true,
    },

    {
      name: "Actions",
      cell: (row) => (
        <>
          <button
            style={{ background: "#1a2131" }}
            className="btn btn-success me-3 border-0  text-white"
            onClick={() => handleUpdate(row)}
          >
            <FaRegEdit />
          </button>
          <button
            style={{ background: "#A0374F" }}
            className="btn btn-danger me-3 text-white border-0"
            onClick={() => handleDelete(row)}
          >
            <BsTrashFill />
          </button>
        </>
      ),
      center: true,
    },
  ];

  const paginatedData = formData.length
    ? formData.slice((page - 1) * perPage, page * perPage)
    : suppliersList.slice((page - 1) * perPage, page * perPage);

  const canSave = [supplier.name, supplier.phone].every(Boolean);
  const canUpdate = [supplier.name, supplier.phone, supplier.email].every(
    Boolean
  );

  return (
    <div>
      <div className="block-content-full">
        <div class="block-content">
          {dataBusiness &&
          dataBusiness.length > 0 &&
          dataBusiness[0].integrated == true ? (
            <>
              <div className="d-flex mb-3">
                <div className="input-group">
                  <input
                    className="form-control"
                    placeholder="Search..."
                    type="text"
                    style={{ height: "40px" }}
                    onChange={handleVendorSearch}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">
                      <IoSearch />
                    </span>
                  </div>
                </div>
              </div>

              <div
                className="table-responsive position-relative p-1 text-left"
                style={{ overflowX: "auto" }}
              >
                <table class="table mb-2 " style={{ minWidth: "800px" }}>
                  <thead className="table-secondary">
                    <tr>
                      <th scope="col">Id</th>
                      <th scope="col">Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentVendors.map((vendor) => {
                      return (
                        <tr>
                          <td>{vendor.value}</td>
                          <td>{vendor.text}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {currentVendors.length > 0 && (
                <div className="">
                  <ul className="pagination justify-content-end">
                    <li
                      className={`page-item ${showPrevious ? "" : "disabled"}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handleVendorPageChange(currentPage - 1)}
                        disabled={!showPrevious}
                      >
                        Previous
                      </button>
                    </li>
                    <li className="page-item disabled">
                      <span className="page-link">{currentPage}</span>
                    </li>
                    <li className={`page-item ${showNext ? "" : "disabled"}`}>
                      <button
                        className="page-link"
                        onClick={() => handleVendorPageChange(currentPage + 1)}
                        disabled={!showNext}
                      >
                        Next
                      </button>
                    </li>
                    <li className="page-item mx-2">
                      <select
                        className="form-select p-0 px-5 py-1 rounded-0"
                        value={itemsPerPage}
                        onChange={handleVendorPerPageChange}
                      >
                        <option value="1">1</option>
                        <option value="3">3</option>
                        <option value="6">6</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                      </select>
                    </li>
                  </ul>
                </div>
              )}
            </>
          ) : (
            <div className="row">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xl-4 col-12">
                <form>
                  <div className="row">
                    {isUpdate && (
                      <div className="col-sm-12">
                        <div className="form-group imageBus">
                          <label>
                            <BsFillCameraFill style={{ fontSize: 30 }} /> <br />
                            <span className={file ? "imageName " : "text-dark"}>
                              {file
                                ? "A logo is selected "
                                : "Select Supplier's Logo (optional)"}
                            </span>
                            <input
                              className="form-control imageFile"
                              type="file"
                              style={{ height: "10px" }}
                              onChange={handleFileChange}
                            />
                          </label>
                        </div>
                      </div>
                    )}
                    <div className="col-sm-12 hover">
                      <div className="mb-3">
                        <div className="row">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label text-start"
                          >
                            Supplier Name
                          </label>
                        </div>
                        <input
                          autoComplete="off"
                          style={{ height: "45px" }}
                          type="text"
                          className="form-control"
                          id="exampleFormControlInput1"
                          placeholder="supplier name"
                          value={supplier.name}
                          onChange={(e) =>
                            setSupplier({ ...supplier, name: e.target.value })
                          }
                        />
                      </div>
                    </div>

                    <div className="col-sm-6 hover">
                      <div className="mb-3">
                        <div className="row">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label text-start"
                          >
                            Supplier Phone
                          </label>
                        </div>
                        <input
                          style={{ height: "45px" }}
                          autoComplete="off"
                          type="text"
                          className="form-control"
                          id="exampleFormControlInput1"
                          placeholder="supplier phone"
                          value={supplier.phone}
                          onChange={(e) =>
                            setSupplier({ ...supplier, phone: e.target.value })
                          }
                        />
                      </div>
                    </div>

                    <div className="col-sm-6 hover">
                      <div className="mb-3">
                        <div className="row">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label text-start"
                          >
                            Supplier Email
                          </label>
                        </div>
                        <input
                          style={{ height: "45px" }}
                          type="email"
                          className="form-control"
                          id="exampleFormControlInput1"
                          placeholder="supplier email"
                          value={supplier.email}
                          onChange={(e) =>
                            setSupplier({ ...supplier, email: e.target.value })
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div class="mt-3 pb-3">
                    <button
                      type="submit"
                      class={
                        isUpdate ? "btn btn-success p-2" : "btn btn-primary p-2"
                      }
                      data-dismiss="modal"
                      onClick={
                        isUpdate ? handleUpdateSupplier : handlecreateSupplier
                      }
                      disabled={isUpdate ? !canUpdate : !canSave}
                    >
                      {isUpdate ? "Update Changes" : "Save changes"}
                    </button>
                    {isUpdate ? (
                      <button
                        type="submit"
                        class={"btn btn-secondary p-2 mx-3"}
                        data-dismiss="modal"
                        onClick={ResetFormChanges}
                      >
                        Reset
                      </button>
                    ) : (
                      <></>
                    )}
                  </div>
                </form>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-12 col-xl-8 col-12 bg-light vh-100">
                <div className="block-content block-content-full">
                  <h2 className="content-heading">Suppliers List</h2>
                  <div className="d-flex mb-3">
                    <div className="input-group">
                      <input
                        className="form-control"
                        placeholder="Search..."
                        type="text"
                        style={{ height: "40px" }}
                        //value={searchText}
                        onChange={handleSearch}
                      />
                      <div className="input-group-append">
                        <span className="input-group-text">
                          <IoSearch />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <DataTable
                  pointerOnHover
                  className="rounded-3"
                  columns={_columns}
                  data={paginatedData}
                  striped
                  highlightOnHover
                  pagination
                  paginationServer
                  paginationTotalRows={suppliersList.length}
                  paginationPerPage={perPage}
                  paginationRowsPerPageOptions={[1, 3, 5, 50]}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerPageChange}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
